/**
 * All Indonesian (Bahasa Indonesia) copy for the kiosk.
 * Centralized so components hold no hardcoded strings — positions us for
 * future i18n without doing the full work now. Source: hanami_frontend.pdf.
 */
export const id = {
  brand: {
    name: 'hanami',
    kanji: '花見',
    tagline: 'SMART CAFE · MAKASSAR',
  },

  welcome: {
    greeting: 'Selamat datang di Hanami',
    subtitle: 'Pesan sendiri, cepat & mudah',
    cta: 'Pesan Sekarang',
    categories: 'Minuman · Makanan · Roti & Kue · Paket',
  },

  orderType: {
    title: 'Makan di sini atau dibawa?',
    subtitle: 'Pilih salah satu untuk lanjut.',
    dineIn: 'Dine In',
    dineInDesc: 'Makan di tempat Hanami',
    callingDevice: 'Calling device tersedia',
    takeAway: 'Take Away',
    takeAwayDesc: 'Bawa pulang',
    nextCta: 'Lanjut Pilih Menu',
  },

  menu: {
    title: 'Menu Hanami',
    allCategory: 'Semua',
    soldOut: 'HABIS',
    selectedCount: (n: number) => `${n} item dipilih`,
    cartCta: 'Keranjang',
    customCount: (n: number) => `${n} kustom`,
  },

  customization: {
    cancel: 'Batal',
    addToCart: 'Tambah ke Keranjang',
    sizeRequired: 'Ukuran',
    required: '*',
  },

  cart: {
    title: 'Keranjang',
    subtotal: 'Subtotal',
    serviceFee: 'Biaya layanan',
    serviceFeeFree: 'Gratis',
    tax: 'Pajak',
    total: 'Total',
    confirmCta: 'Konfirmasi Pesanan',
    empty: {
      title: 'Keranjang kosong',
      subtitle: 'Pilih menu untuk mulai memesan.',
      cta: 'Lihat Menu',
    },
  },

  confirmation: {
    title: 'Konfirmasi',
    total: 'Total',
    payAtCounterTitle: 'Bayar di Counter',
    payAtCounterBody:
      'Struk dengan nomor pesanan akan tercetak. Bawa struk ke counter untuk pembayaran.',
    payAtCounterValidity: 'Berlaku 15 menit setelah cetak.',
    printCta: 'Cetak Struk & Lanjut',
    backToCart: 'Kembali ke Keranjang',
    priceUpdated: 'Harga diperbarui',
    itemsUnavailable: 'Beberapa item tidak lagi tersedia. Silakan tinjau pesanan.',
  },

  instructions: {
    titlePrinting: 'Mencetak Struk…',
    printingBody: 'Mohon tunggu, struk sedang dicetak',
    titlePrinted: 'Struk Tercetak',
    titleFailed: 'Struk Gagal',
    showAtCounter: 'Tunjukkan nomor ini di counter',
    receiptUnpaid: 'BELUM DIBAYAR',
    steps: [
      'Ambil struk yang tercetak',
      'Serahkan struk ke counter',
      'Lakukan pembayaran (tunai / non-tunai)',
      'Terima calling device / tunggu dipanggil',
    ],
    validUntil: (time: string) => `Berlaku hingga ${time} WITA`,
    newTransaction: 'Transaksi Baru',
    printFailedTitle: 'Struk gagal dicetak',
    printFailedBody: 'Tunjukkan layar ini ke counter — struk akan dicetak ulang.',
  },

  takeAwayModal: {
    title: 'Nama untuk pesanan',
    placeholder: 'Nama',
    maxLength: 'Maks. 20 karakter',
    confirm: 'Konfirmasi',
    skip: 'Lewati',
  },

  idle: {
    title: 'Masih di sini?',
    subtitle: 'Tap untuk melanjutkan pesanan.',
    continue: (seconds: number) => `Lanjutkan (${seconds})`,
  },

  toast: {
    addedToCart: 'Ditambahkan ke keranjang',
    printerOffline: 'Printer tidak terhubung',
  },

  banner: {
    offline: 'Pesanan sementara tidak tersedia — coba lagi sebentar',
  },

  badge: {
    dineIn: 'Dine In',
    takeAway: 'Take Away',
    paid: 'PAID',
    void: 'VOID',
    new: 'Baru',
    bestseller: 'Bestseller',
  },

  common: {
    back: 'Kembali',
    rupiahPrefix: 'Rp',
    loading: 'Memuat…',
    errorTitle: 'Terjadi kesalahan',
    errorBody: 'Silakan ulangi atau hubungi staf.',
  },
} as const;

export type Strings = typeof id;
